import styled from "styled-components";

import { IconButton, Textfield } from "@similarweb/ui-components";

export const StyledCrmEnrichmentFilterContainer = styled.div`
    position: relative;
    display: flex;
    margin: 8px 32px;
`;

export const StyledCrmEnrichmentFilterDeleteIconButton = styled(IconButton)`
    margin-left: 16px;
    flex: none;
`;

export const StyledCrmEnrichmentFilterTextfield = styled(Textfield)`
    width: 100%;
`;

export const StyledCrmEnrichmentFilterWrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: 230px;
    margin-right: 8px;
`;
